import React from 'react';
import PropTypes from 'prop-types';
import { compose } from "recompose";
import { withRouter } from "react-router-dom";
import { withStyles, TableContainer, Table, TableBody, IconButton } from "@material-ui/core";
import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight';
import CarDetailsHeader from './CarDetails/CarDetailsHeader';
import guid from './../../utils/guid';
import CarDetailsRow from './CarDetails/CarDetailsRow';
import NoData from './NoDataRow';

const useStyles = () => ({
    tableContainer: {
        maxHeight: "55vh"
    },
    cell: {
        textAlign: "center",
        padding: 0
    }
});

const AssignedCarsList = props => {
    const { classes, data = [] } = props;

    const handleArrowClick = (value) => {
        props.history.push({
            pathname: "/cars",
            search: `?ids=${value}`
        });
    };

    const printTable = (data) => {
        if (!Array.isArray(data) || data.length === 0)
            return <NoData colSpan={9} />;
        return data.map(row => {
            return (
                <CarDetailsRow
                    key={guid()}
                    classes={{cell: classes.cell}}
                    registrationNo={row.rejestracja}
                    brand={row.marka}
                    model={row.model}
                    description={row.opis}
                    service={row.serwis}
                    ecoGrade={row.eco}
                    fuelLevel={row.stan_paliwa}
                    state="Wolny"
                    lastCellContent={
                        <IconButton
                            onClick={handleArrowClick.bind(this, row.rejestracja)}
                        >
                            <KeyboardArrowRightIcon />
                        </IconButton>
                    }
                />
            );
        });
    };

    return (
        <TableContainer className={classes.tableContainer}>
            <Table stickyHeader>
                <CarDetailsHeader />
                <TableBody>
                    {printTable(data)}
                </TableBody>
            </Table>
        </TableContainer>
    );
};

AssignedCarsList.propTypes = {
    classes: PropTypes.object,
    data: PropTypes.array,
    //router
    history: PropTypes.object
};

export default compose(
    withStyles(useStyles),
    withRouter
)(AssignedCarsList);
